<template>
  <tr class="search__formfields">
    <td class="search__formfields__td--labelCode">
      <input type="text" name="labelCode" class="search__formfield__input--labelCode" v-model="search.labelCode">
    </td>
    <td class="search__formfields__td--label">
      <input type="text" name="label" class="search__formfield__input--label" v-model="search.label">
    </td>
    <td class="search__formfields__td--shortName">
      <input type="text" name="shortName" class="search__formfield__input--shortName" v-model="search.shortName">
    </td>
    <td class="search__formfields__td--plm">
      <select name="plm" class="search__formfield__input--plm" v-model="search.plm">
        <option value="">-</option>
        <option value="1">Ja</option>
        <option value="0">Nein</option>
      </select>
    </td>
    <td class="search__formfields__td--producer">
      <input type="text" name="companyName" class="search__formfield__input--producer" v-model="search.companyName">
    </td>
    <td class="search__formfields__td--rightrecalls">
      <select name="restrictions" class="search__formfield__input--rightrecalls" v-model="search.restrictions">
        <option value="">-</option>
        <option value="1">Ja</option>
        <option value="0">Nein</option>
      </select>
    </td>
  </tr>
</template>

<script>
import SearchModel from './Model.class.ts'

export default {
  name: 'SearchForm',
  components: {
  },
  props: {},
  data () {
    return {
      search: new SearchModel(this.$route.query)
    }
  },
  mounted () {
    this.$log.debug('SearchForm::search: ', this.search, '$store: ', this.$store)
    this.$parent.search = this.search
  }
}
</script>

<style lang="scss">
  .search__formfields {
    td {
      border-bottom: 1px solid black;
    }

    .search__formfields__td--labelCode {
      width: 10%;
      .search__formfield__input--labelCode {
        width: 93%;
      }
    }
    .search__formfields__td--label {
      width: 20%;
      .search__formfield__input--label {
        width: 97%;
      }
    }
    .search__formfields__td--shortName {
      width: 10%;
      .search__formfield__input--shortName {
        width: 95%;
      }
    }
    .search__formfields__td--plm {
      width: 5%;
      text-align: center;
      .search__formfield__input--plm {
        min-width: 5em;
        width: 100%;
      }
    }
    .search__formfields__td--producer {
      width: 40%;
      .search__formfield__input--producer {
        width: 99%;
      }
    }
    .search__formfields__td--rightrecalls {
      width: 15%;
      text-align: center;
      .search__formfield__input--rightrecalls {
        min-width: 5em;
        width: 100%;
      }
    }
  }
</style>
